// @flow
import { useLoaderData } from 'react-router-dom';
import type { Landing } from '../../generated/graphql';

const useLandingData = (): Landing => useLoaderData().data.landing;

export default useLandingData;
